// extracted by mini-css-extract-plugin
export default {"Rcard":"ReferralCard_Rcard__hd9MI","ReferralTxt":"ReferralCard_ReferralTxt__AlGM4"};